// src/pages/info/DBHouse.jsx
import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom'
import { FaSearch, FaPlus } from 'react-icons/fa';
import DBHouseTable from '../../../components/Directory/DBHouseTable';
import AddHouseModal from '../../../components/Modals/AddHouseModal';
import '../../CheckPage/CheckPage.css'; 

const DBHouse = () => {

  const [reloadKey, setReloadKey] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);


useEffect(() => {
  const handleFocus = () => setReloadKey(prev => prev + 1);
  window.addEventListener('focus', handleFocus);
  return () => window.removeEventListener('focus', handleFocus);
}, []);


  const handleSearch = () => {
    // сюда можно добавить логи или трекинг поиска
    console.log('Поиск:', query);
  };

    const [query, setQuery] = useState(() => localStorage.getItem('houseQuery') || '')
    const [selectedHouseId, setSelectedHouseId] = useState(() => localStorage.getItem('selectedHouseId') || null)

    useEffect(() => {
      localStorage.setItem('houseQuery', query)
    }, [query])

    const navigate = useNavigate()

  const onKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="check-page">
      <h1 className="page-title">База данных домов в г. Норильск</h1>

      <div className="toolbar">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Поиск по домам г. Норильска"
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button
            type="button"
            className="search-btn"
            onClick={handleSearch}
            title="Искать"
          >
            <FaSearch />
          </button>
        </div>

        <button
          className="primary-btn"
          onClick={() => setShowAddModal(true)}
        >
          <FaPlus style={{ marginRight: 6 }} />
          Новый дом
        </button>

      </div>

      <div className="table-area">
        {/* Передаём строку поиска в таблицу */}
        <DBHouseTable 
        key={reloadKey}
        query={query}
        selectedHouseId={selectedHouseId}
        onRowSelect={id => {
          setSelectedHouseId(id)
          localStorage.setItem('selectedHouseId', id)
          navigate(`/db-house/${id}`)
        }}
      />
      </div>
      {showAddModal && (
        <AddHouseModal
        onClose={() => setShowAddModal(false)}
        onAdded={(newId) => {
          setSelectedHouseId(newId);       // подсветить строку
          setReloadKey(prev => prev + 1);  // перерисовать таблицу
          setShowAddModal(false);
        }}
        />
      )}
    </div>
  );
};

export default DBHouse;
